import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

// components
import SharedFavoritesProvider from '../../../sharedComponents/SharedFavoritesProvider';
import { FeedTile } from './FeedTile/FeedTile';
import { Masonry } from './Masonry/Masonry';

// helpers
import { trackTileClick } from './helpers/discoverFeedTracking';

function DiscoverFeedTilesComponent({ discoveryFeed, userId, viewer, relay }) {
    const favoritesProviderProps = {
        userId,
        environment: relay.environment,
        itemIds: discoveryFeed
            .map(discoveryFeedTile => get(discoveryFeedTile, 'itemId') || null)
            .filter(Boolean),
        fetchFavorites: !!userId,
        viewer,
    };

    return (
        <SharedFavoritesProvider {...favoritesProviderProps}>
            {({ favorites }) => (
                <Masonry>
                    {discoveryFeed.map((discoveryFeedTile, index) => (
                        <FeedTile
                            key={`${discoveryFeedTile.title}${discoveryFeedTile.ctaUrl}`}
                            discoveryFeedTile={discoveryFeedTile}
                            trackTileClick={() => {
                                trackTileClick({
                                    tileType: discoveryFeedTile.tileType,
                                    ctaUrl: discoveryFeedTile.ctaUrl,
                                    index,
                                });
                            }}
                            userId={userId}
                            viewer={viewer}
                            sharedFavoritesProps={favorites}
                        />
                    ))}
                </Masonry>
            )}
        </SharedFavoritesProvider>
    );
}

DiscoverFeedTilesComponent.propTypes = {
    userId: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    relay: PropTypes.object,
    discoveryFeed: PropTypes.array.isRequired,
};

export const DiscoverFeedTiles = createFragmentContainer(DiscoverFeedTilesComponent, {
    viewer: graphql`
        fragment DiscoverFeedTiles_viewer on Viewer {
            ...SharedFavoritesProvider_viewer
        }
    `,
});
